import { Component } from '@angular/core';

@Component({
   selector: 'consignee-billing-party',
   template: `<billing-party party="consignee"></billing-party>`,
})
export class ConsigneeBillingPartyComponent {}
